import styled from '@emotion/styled';
import StyledFieldName from '../../TypeSpecificFieldRenderers/utils/FieldName/StyledFieldName';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { lighten } from '@mui/system';
import FieldNameWrapper from '../../TypeSpecificFieldRenderers/utils/FieldName/FieldNameWrapper';
import { FormattedMessage } from 'react-intl';

type CoachCommentFormTitleProps = {
  isPurple: boolean;
};

const StyledCoachCommentFormTitle = styled(
  StyledFieldName,
)<CoachCommentFormTitleProps>(
  ({ theme, isPurple }) => ({
    color: isPurple
      ? theme.isDark
        ? lighten(theme.palette.sliders.coach, 0.4)
        : theme.palette.sliders.coach
      : undefined,
  }),
  addHighContrastStyles(({ theme, isPurple }) => ({
    color: isPurple ? theme.palette.text.primary : undefined,
  })),
);

const CoachCommentFormTitle = ({ isPurple }: CoachCommentFormTitleProps) => (
  <FieldNameWrapper>
    <StyledCoachCommentFormTitle isPurple={isPurple}>
      <FormattedMessage id="portfolio.challenge.coach_comments.add.title" />
    </StyledCoachCommentFormTitle>
  </FieldNameWrapper>
);

export default CoachCommentFormTitle;
